import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tv, Radio, ExternalLink } from "lucide-react";

const CHANNELS = [
  { id: "aljazeera", name: "Al Jazeera English", videoId: "gCNeDWCI0vo", ytHandle: "aljazeeraenglish", lang: "EN" },
  { id: "euronews", name: "Euronews", videoId: "pykpO5kQJ98", ytHandle: "euronews", lang: "EN" },
  { id: "ndtv", name: "NDTV 24x7", videoId: "MN8p-Vrn6G0", ytHandle: "ndtv", lang: "EN" },
  { id: "trt", name: "TRT World", videoId: "TV4Wp1I3-8c", ytHandle: "TRTWorld", lang: "EN" },
  { id: "france24", name: "France 24 English", videoId: "SKdRx_DsoVo", ytHandle: "FRANCE24English", lang: "EN" },
  { id: "dw", name: "DW News", videoId: "pqabxBKzZ6o", ytHandle: "DWNews", lang: "EN" },
  { id: "skynews", name: "Sky News", videoId: "siyW0GOBtUo", ytHandle: "skynews", lang: "EN" },
  { id: "abc", name: "ABC News", videoId: "YVhWGMOae4Q", ytHandle: "ABCNews", lang: "EN" },
];

const LiveNewsTV = () => {
  const [active, setActive] = useState(CHANNELS[0]);

  const handleChannelSwitch = (ch: typeof CHANNELS[0]) => {
    setActive(ch);
  };

  return (
    <section id="live-news" className="container mx-auto px-4 py-10">
      <Card className="border-border bg-card">
        <CardHeader className="pb-3">
          <CardTitle className="flex items-center gap-2 text-base font-mono uppercase tracking-wider text-foreground">
            <Tv className="h-4 w-4 text-[hsl(var(--danger))]" />
            Live News TV
            <span className="ml-2 flex items-center gap-1 rounded-full bg-[hsl(var(--danger))]/20 px-2 py-0.5 text-[10px] text-[hsl(var(--danger))]">
              <Radio className="h-2.5 w-2.5 animate-pulse" /> LIVE
            </span>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-wrap gap-1.5 mb-4">
            {CHANNELS.map((ch) => (
              <button
                key={ch.id}
                onClick={() => handleChannelSwitch(ch)}
                className={`rounded px-2.5 py-1.5 text-xs font-medium transition-colors ${
                  active.id === ch.id
                    ? "bg-primary text-primary-foreground"
                    : "bg-secondary text-muted-foreground hover:text-foreground hover:bg-accent"
                }`}
              >
                {ch.name}
              </button>
            ))}
          </div>

          <div className="relative w-full overflow-hidden rounded-lg border border-border" style={{ paddingBottom: "56.25%" }}>
            <iframe
              key={active.videoId}
              className="absolute inset-0 h-full w-full"
              src={`https://www.youtube.com/embed/${active.videoId}?autoplay=1&mute=1`}
              title={active.name}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>

          <div className="mt-2 flex items-center justify-between">
            <p className="text-[10px] text-muted-foreground">
              Streams hosted by respective broadcasters on YouTube. Availability may vary.
            </p>
            <a
              href={`https://www.youtube.com/@${active.ytHandle}/streams`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-[10px] text-primary hover:underline"
            >
              Open on YouTube <ExternalLink className="h-2.5 w-2.5" />
            </a>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};

export default LiveNewsTV;
